module.exports = __webpack_public_path__ + "static/media/buy_finish_service_make_5.0a407c4e.jpg";